import React, { useState } from 'react'
import logo0 from '../../assets/social/instagram.svg'
import logo1 from '../../assets/social/facebook-messenger.svg'
import logo2 from '../../assets/social/whatsapp.svg'
import Search from "../../assets/general/searchWhite.svg";
import AddGuestsPost from '../Components/AddGuestsPost'
import './AddGuestPage.css'

function AddGuestPage(props) {
  const [search, setSearch] = useState('');
  return (
    <div className='col' style={{height:"93vh",justifyContent:'space-between'}}>
      <div className='col' style={{gap:10}}>
        <div className="addguests-header">
          <h4 className="addguests-share">Share</h4>
          <p className="addguests-sidebar">|</p>
          <div className="addguest-compnents">
            <img src={logo0} className="addguests-icon" />
            <p className="addguests-text">Story</p>
          </div>
          <div className="addguest-compnents">
            <img src={logo0} className="addguests-icon" />
            <p className="addguests-text">instagram</p>
          </div>
          <div className="addguest-compnents">
            <img src={logo1} className="addguests-icon" />
            <p className="addguests-text">Messanger</p>
          </div>
          <div className="addguest-compnents">
            <img src={logo2} className="addguests-icon" />
            <p className="addguests-text">Whatsapp</p>
          </div>
          <p className="addguests-sidebar">|</p>
          <button className="addguests-morebutton">More</button>
        </div>
        <div className='col' style={{ alignItems: 'center' }}>
          <div className="row search-bar-container" style={{
            alignItems: "center",
            padding: 5,
            paddingLeft: 10,
          }}>
            <img src={Search} style={{
              width: 20,
              height: 20,
            }} />
            <input className="search-bar"
              placeholder="Search name"
              value={search}
            // onChange={(e) => searchFilter(e.target.value)}
            />
          </div>
        </div>
        <div className='col'>
          <AddGuestsPost owner="Hamza" id="@hamzasurge" />
          <AddGuestsPost owner="Hamza" id="@hamzasurge" />
          <AddGuestsPost owner="Hamza" id="@hamzasurge" />
          <AddGuestsPost owner="Hamza" id="@hamzasurge" />
        </div>
      </div>            
      <div className="">
        <button className="addguests-uploadbutton">Upload your music taste</button>
      </div>
    </div>
  )
}

export default AddGuestPage